import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { PageHero } from "./AboutPage";
import { Solutions, StaffingServices, Industries } from "../components/landing/Showcase";
import { useLang } from "../context/LanguageContext";

export default function SolutionsPage() {
  const { t } = useLang();
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth" }), 400);
    }
  }, [hash]);

  return (
    <div className="bg-[#FAF7F2] min-h-screen" data-testid="solutions-page">
      <Header />
      <PageHero overline={t("solutions.overline")} title={t("solutions.title")} sub={t("solutions.sub")} testid="solutions-title" img="/assets/svc-executive.jpg" />
      <Solutions />
      <StaffingServices />
      <Industries />
      <Footer />
    </div>
  );
}
